import { createStore } from 'vuex';

export default createStore({
    state: {
        user: localStorage.getItem('user')
    },
    mutations: {
        setUser(state, user) {
            state.user = user
            localStorage.setItem('user', user)
        },
    },
    getters: {
        getUser(state) {
            if (!state.user) {
                state.user = localStorage.getItem('user')
            }
            return state.user
        }
    },
    actions: {}
})
